import React from 'react';
import { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import AuthContext from '../context/AuthContext';

export default function PrivateRoute() {
    const { isAuthenticated } = useContext(AuthContext);
	return isAuthenticated === true ? <Outlet /> : <Navigate to="/login" />;
}